export default {
  // draggable dynamic table
  draggableDynamicTable: {

    filters: 'filters',
    defaultFilters: 'Default Filter',

    filter: {
      all: 'All',
      none: 'None',

      types: {
        search: 'Include',
        equals: 'Equal',
        notEqual: 'Not Equal',
        lessThanEquals: 'Less Than Equal',
        greaterThanEquals: 'Greater Than Equal'
      }
    },

    activeFilters: {
      title: 'Applied filters'
    },

    setting: {
      showColumns: 'Show Columns'
    },

    notifications: {
      loading: 'Loading information ...',
      error: 'Error receiving information',
      empty: 'No information available'
    },

    actions: {
      print: 'Print',
      download: 'Download',
      setting: 'Table settings'
    }
  },

  // navbar actions
  navbar: {
    back: 'Back',
    save: 'Save',
    dynamicFinancialYear: 'Financial year {start} to {end}',

    notification: {
      newMessage: 'New message',
      showAll: 'View all notifications'
    }
  },

  // accessTreeCheckBox
  accessTreeCheckBox: {
    labels: {
      chooseCategory: 'Choose access'
    }
  },

  // custom dialog
  customDialog: {
    confirm: 'Confirm',
    cancel: 'Cancel'
  },

  // custom file input
  customFileInput: {
    labels: {
      dragDrop: 'Drag file here or browse'
    },
    uploaded: 'Your photo has been uploaded',
    sizeError: 'File size must be less than {size} kilobytes!'
  },

  // customProfileImageInput
  customProfileImageInput: {
    validators: {
      imageSize: 'The image size must be less than {size} kilobytes!'
    }
  },

  // custom date picker input
  customDatePickerInput: {
    invalidText: 'The entered field is not valid'
  },

  // custom auto complete
  customAutoComplete: {
    notFound: 'No matches found',
    emptyCreateNew: 'Create new item'
  },

  // custom wizard
  customWizard: {
    next: 'Next',
    previous: 'Previous'
  },

  // contextMenu
  contextMenu: {
    actions: {
      openNewTab: 'Open in new tab',
      copyLink: 'Copy link address',
      copy: 'Copy',
      paste: 'Paste'
    },
    notifications: {
      clipboard: 'Copied to clipboard!'
    }
  },

  // date picker
  datePicker: {
    labels: {
      submit: 'Confirm',
      cancel: 'cancel',
      now: 'now',
      nextMonth: 'next month',
      prevMonth: 'month ago'
    }
  },

  chat: {
    title: 'Chats'
  },

  smsMessageInput: {
    title: 'Send message',

    labels: {
      receiverCount: 'Receiver count',
      message: 'Message'
    },

    notifications: {
      send: {
        success: 'Send message successfully done',
        error: 'Send message has error'
      }
    },

    validators: {
      invalidMessage: 'Message text is not valid',
      receiverCount: 'No receiver exist'
    }
  },

  updateInvoiceProgressbar: {
    title: 'Update invoices progressbar',

    labels: {
      seeMore: 'See more',
      sale_invoice: 'Sale invoice No. {id} created',
      return_sale_invoice: 'Sale refund invoice No. {id} created',
      purchase_invoice: 'Purchase invoice No. {id} created',
      return_purchase_invoice: 'Purchase refund invoice No. {id} created',
      transfer: 'Warehouse transfer No. {id} created',
      storeroom_conversion: 'Warehouse conversion No. {id} created',
      storeroom_deficit: 'Warehouse deficit No. {id} created',
      storeroom_surplus: 'Warehouse surplus No. {id} created',
      updateDone: 'Updates successfully done'
    }
  },

  profile: {
    title: 'Profile',

    invoice: {
      items: 'Items',
      addItem: 'Add Item',

      footerDetails: {
        labels: {
          totalItems: 'Total Items',
          totalDiscount: 'Total Discount',
          totalVat: 'Total Vat',
          grandTotal: 'Grand Total'
        }
      }
    }
  },

  plan: {
    labels: {
      addons: 'Addons',
      currentPlan: 'Current',
      periodPerMonth: ' / {num} mo'
    },

    addons: {
      slugName: {
        users: 'Users ',
        products: 'Products ',
        advanced_products: 'Advanced products',
        services: 'Services ',
        sales: 'Sales',
        purchases: 'Purchases',
        treasury: 'Treasury',
        events: 'Events',
        support_tickets: 'Support Tickets',
        financial_years: 'Financial Years',
        settings: 'Settings',
        point: 'Point',
        max_debt: 'Credit',
        users_group: 'Users group',
        deficits: 'Deficits',
        conversions: 'Conversions',
        costs: 'Costs',
        sale_suggest: 'Sale suggest',
        purchase_suggest: 'Purchase suggest',
        reports: 'Reports',
        points: 'Points',
        roles: 'Roles',
        warehouses: 'Warehouses',
        accountancy: 'Accountancy',
        organizational_tickets: 'Internal Tickets',
        woocommerce: 'Woocommerce',
        connector: 'Woocommerce',
        backups: 'Backups',
        company: 'Company',
        addons: {
          points: 'Point',
          max_debt: 'Credit',
          users_group: 'Users group',
          deficits: 'Deficits',
          conversions: 'Conversions',
          costs: 'Costs',
          cost: 'Cost',
          tax: 'Vat',
          opening_inventory: 'Opening inventory',
          ai_suggest: 'Ai Suggest',
          woocommerce_connector: 'Woocommerce connector',
          cross_currency_pricing: 'Cross currency pricing',
          sale_report_by_attributes: 'Sale report by attribute',
          sale_report_by_customer: 'Sale report by customer'
        }
      }
    }
  }
}
